/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiUserFeedbackControllerCreateMutationRequest, AiUserFeedbackControllerCreateMutationResponse, AiUserFeedbackControllerCreate400, AiUserFeedbackControllerCreate401 } from "../../models/aiUserFeedbackController/AiUserFeedbackControllerCreate";

function getAiUserFeedbackControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/ai-user-feedback` as const }  
  return res
}

/**
 * @summary Create AI user feedback
 * {@link /api/v1/ai-user-feedback}
 */
export async function aiUserFeedbackControllerCreate(data?: AiUserFeedbackControllerCreateMutationRequest, config: Partial<RequestConfig<AiUserFeedbackControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<AiUserFeedbackControllerCreateMutationResponse, ResponseErrorConfig<AiUserFeedbackControllerCreate400 | AiUserFeedbackControllerCreate401>, AiUserFeedbackControllerCreateMutationRequest>({ method : "POST", url : getAiUserFeedbackControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}